import { __assign } from "tslib";
import { isa as __isa } from "@aws-sdk/smithy-client";
export var AddTagsToStreamInput;
(function (AddTagsToStreamInput) {
    AddTagsToStreamInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AddTagsToStreamInput.isa = function (o) { return __isa(o, "AddTagsToStreamInput"); };
})(AddTagsToStreamInput || (AddTagsToStreamInput = {}));
export var Consumer;
(function (Consumer) {
    Consumer.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Consumer.isa = function (o) { return __isa(o, "Consumer"); };
})(Consumer || (Consumer = {}));
export var ConsumerDescription;
(function (ConsumerDescription) {
    ConsumerDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ConsumerDescription.isa = function (o) { return __isa(o, "ConsumerDescription"); };
})(ConsumerDescription || (ConsumerDescription = {}));
export var ConsumerStatus;
(function (ConsumerStatus) {
    ConsumerStatus["ACTIVE"] = "ACTIVE";
    ConsumerStatus["CREATING"] = "CREATING";
    ConsumerStatus["DELETING"] = "DELETING";
})(ConsumerStatus || (ConsumerStatus = {}));
export var CreateStreamInput;
(function (CreateStreamInput) {
    CreateStreamInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateStreamInput.isa = function (o) { return __isa(o, "CreateStreamInput"); };
})(CreateStreamInput || (CreateStreamInput = {}));
export var DecreaseStreamRetentionPeriodInput;
(function (DecreaseStreamRetentionPeriodInput) {
    DecreaseStreamRetentionPeriodInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DecreaseStreamRetentionPeriodInput.isa = function (o) {
        return __isa(o, "DecreaseStreamRetentionPeriodInput");
    };
})(DecreaseStreamRetentionPeriodInput || (DecreaseStreamRetentionPeriodInput = {}));
export var DeleteStreamInput;
(function (DeleteStreamInput) {
    DeleteStreamInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteStreamInput.isa = function (o) { return __isa(o, "DeleteStreamInput"); };
})(DeleteStreamInput || (DeleteStreamInput = {}));
export var DeregisterStreamConsumerInput;
(function (DeregisterStreamConsumerInput) {
    DeregisterStreamConsumerInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeregisterStreamConsumerInput.isa = function (o) { return __isa(o, "DeregisterStreamConsumerInput"); };
})(DeregisterStreamConsumerInput || (DeregisterStreamConsumerInput = {}));
export var DescribeLimitsInput;
(function (DescribeLimitsInput) {
    DescribeLimitsInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeLimitsInput.isa = function (o) { return __isa(o, "DescribeLimitsInput"); };
})(DescribeLimitsInput || (DescribeLimitsInput = {}));
export var DescribeLimitsOutput;
(function (DescribeLimitsOutput) {
    DescribeLimitsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeLimitsOutput.isa = function (o) { return __isa(o, "DescribeLimitsOutput"); };
})(DescribeLimitsOutput || (DescribeLimitsOutput = {}));
export var DescribeStreamConsumerInput;
(function (DescribeStreamConsumerInput) {
    DescribeStreamConsumerInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeStreamConsumerInput.isa = function (o) { return __isa(o, "DescribeStreamConsumerInput"); };
})(DescribeStreamConsumerInput || (DescribeStreamConsumerInput = {}));
export var DescribeStreamConsumerOutput;
(function (DescribeStreamConsumerOutput) {
    DescribeStreamConsumerOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeStreamConsumerOutput.isa = function (o) { return __isa(o, "DescribeStreamConsumerOutput"); };
})(DescribeStreamConsumerOutput || (DescribeStreamConsumerOutput = {}));
export var DescribeStreamInput;
(function (DescribeStreamInput) {
    DescribeStreamInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeStreamInput.isa = function (o) { return __isa(o, "DescribeStreamInput"); };
})(DescribeStreamInput || (DescribeStreamInput = {}));
export var DescribeStreamOutput;
(function (DescribeStreamOutput) {
    DescribeStreamOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeStreamOutput.isa = function (o) { return __isa(o, "DescribeStreamOutput"); };
})(DescribeStreamOutput || (DescribeStreamOutput = {}));
export var DescribeStreamSummaryInput;
(function (DescribeStreamSummaryInput) {
    DescribeStreamSummaryInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeStreamSummaryInput.isa = function (o) { return __isa(o, "DescribeStreamSummaryInput"); };
})(DescribeStreamSummaryInput || (DescribeStreamSummaryInput = {}));
export var DescribeStreamSummaryOutput;
(function (DescribeStreamSummaryOutput) {
    DescribeStreamSummaryOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeStreamSummaryOutput.isa = function (o) { return __isa(o, "DescribeStreamSummaryOutput"); };
})(DescribeStreamSummaryOutput || (DescribeStreamSummaryOutput = {}));
export var DisableEnhancedMonitoringInput;
(function (DisableEnhancedMonitoringInput) {
    DisableEnhancedMonitoringInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DisableEnhancedMonitoringInput.isa = function (o) { return __isa(o, "DisableEnhancedMonitoringInput"); };
})(DisableEnhancedMonitoringInput || (DisableEnhancedMonitoringInput = {}));
export var EnableEnhancedMonitoringInput;
(function (EnableEnhancedMonitoringInput) {
    EnableEnhancedMonitoringInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EnableEnhancedMonitoringInput.isa = function (o) { return __isa(o, "EnableEnhancedMonitoringInput"); };
})(EnableEnhancedMonitoringInput || (EnableEnhancedMonitoringInput = {}));
export var EncryptionType;
(function (EncryptionType) {
    EncryptionType["KMS"] = "KMS";
    EncryptionType["NONE"] = "NONE";
})(EncryptionType || (EncryptionType = {}));
export var EnhancedMetrics;
(function (EnhancedMetrics) {
    EnhancedMetrics.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EnhancedMetrics.isa = function (o) { return __isa(o, "EnhancedMetrics"); };
})(EnhancedMetrics || (EnhancedMetrics = {}));
export var EnhancedMonitoringOutput;
(function (EnhancedMonitoringOutput) {
    EnhancedMonitoringOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EnhancedMonitoringOutput.isa = function (o) { return __isa(o, "EnhancedMonitoringOutput"); };
})(EnhancedMonitoringOutput || (EnhancedMonitoringOutput = {}));
export var ExpiredIteratorException;
(function (ExpiredIteratorException) {
    ExpiredIteratorException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ExpiredIteratorException.isa = function (o) { return __isa(o, "ExpiredIteratorException"); };
})(ExpiredIteratorException || (ExpiredIteratorException = {}));
export var ExpiredNextTokenException;
(function (ExpiredNextTokenException) {
    ExpiredNextTokenException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ExpiredNextTokenException.isa = function (o) { return __isa(o, "ExpiredNextTokenException"); };
})(ExpiredNextTokenException || (ExpiredNextTokenException = {}));
export var GetRecordsInput;
(function (GetRecordsInput) {
    GetRecordsInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetRecordsInput.isa = function (o) { return __isa(o, "GetRecordsInput"); };
})(GetRecordsInput || (GetRecordsInput = {}));
export var GetRecordsOutput;
(function (GetRecordsOutput) {
    GetRecordsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetRecordsOutput.isa = function (o) { return __isa(o, "GetRecordsOutput"); };
})(GetRecordsOutput || (GetRecordsOutput = {}));
export var GetShardIteratorInput;
(function (GetShardIteratorInput) {
    GetShardIteratorInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetShardIteratorInput.isa = function (o) { return __isa(o, "GetShardIteratorInput"); };
})(GetShardIteratorInput || (GetShardIteratorInput = {}));
export var GetShardIteratorOutput;
(function (GetShardIteratorOutput) {
    GetShardIteratorOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetShardIteratorOutput.isa = function (o) { return __isa(o, "GetShardIteratorOutput"); };
})(GetShardIteratorOutput || (GetShardIteratorOutput = {}));
export var HashKeyRange;
(function (HashKeyRange) {
    HashKeyRange.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    HashKeyRange.isa = function (o) { return __isa(o, "HashKeyRange"); };
})(HashKeyRange || (HashKeyRange = {}));
export var IncreaseStreamRetentionPeriodInput;
(function (IncreaseStreamRetentionPeriodInput) {
    IncreaseStreamRetentionPeriodInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    IncreaseStreamRetentionPeriodInput.isa = function (o) {
        return __isa(o, "IncreaseStreamRetentionPeriodInput");
    };
})(IncreaseStreamRetentionPeriodInput || (IncreaseStreamRetentionPeriodInput = {}));
export var InternalFailureException;
(function (InternalFailureException) {
    InternalFailureException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InternalFailureException.isa = function (o) { return __isa(o, "InternalFailureException"); };
})(InternalFailureException || (InternalFailureException = {}));
export var InvalidArgumentException;
(function (InvalidArgumentException) {
    InvalidArgumentException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InvalidArgumentException.isa = function (o) { return __isa(o, "InvalidArgumentException"); };
})(InvalidArgumentException || (InvalidArgumentException = {}));
export var KMSAccessDeniedException;
(function (KMSAccessDeniedException) {
    KMSAccessDeniedException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    KMSAccessDeniedException.isa = function (o) { return __isa(o, "KMSAccessDeniedException"); };
})(KMSAccessDeniedException || (KMSAccessDeniedException = {}));
export var KMSDisabledException;
(function (KMSDisabledException) {
    KMSDisabledException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    KMSDisabledException.isa = function (o) { return __isa(o, "KMSDisabledException"); };
})(KMSDisabledException || (KMSDisabledException = {}));
export var KMSInvalidStateException;
(function (KMSInvalidStateException) {
    KMSInvalidStateException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    KMSInvalidStateException.isa = function (o) { return __isa(o, "KMSInvalidStateException"); };
})(KMSInvalidStateException || (KMSInvalidStateException = {}));
export var KMSNotFoundException;
(function (KMSNotFoundException) {
    KMSNotFoundException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    KMSNotFoundException.isa = function (o) { return __isa(o, "KMSNotFoundException"); };
})(KMSNotFoundException || (KMSNotFoundException = {}));
export var KMSOptInRequired;
(function (KMSOptInRequired) {
    KMSOptInRequired.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    KMSOptInRequired.isa = function (o) { return __isa(o, "KMSOptInRequired"); };
})(KMSOptInRequired || (KMSOptInRequired = {}));
export var KMSThrottlingException;
(function (KMSThrottlingException) {
    KMSThrottlingException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    KMSThrottlingException.isa = function (o) { return __isa(o, "KMSThrottlingException"); };
})(KMSThrottlingException || (KMSThrottlingException = {}));
export var LimitExceededException;
(function (LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    LimitExceededException.isa = function (o) { return __isa(o, "LimitExceededException"); };
})(LimitExceededException || (LimitExceededException = {}));
export var ListShardsInput;
(function (ListShardsInput) {
    ListShardsInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListShardsInput.isa = function (o) { return __isa(o, "ListShardsInput"); };
})(ListShardsInput || (ListShardsInput = {}));
export var ListShardsOutput;
(function (ListShardsOutput) {
    ListShardsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListShardsOutput.isa = function (o) { return __isa(o, "ListShardsOutput"); };
})(ListShardsOutput || (ListShardsOutput = {}));
export var ListStreamConsumersInput;
(function (ListStreamConsumersInput) {
    ListStreamConsumersInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListStreamConsumersInput.isa = function (o) { return __isa(o, "ListStreamConsumersInput"); };
})(ListStreamConsumersInput || (ListStreamConsumersInput = {}));
export var ListStreamConsumersOutput;
(function (ListStreamConsumersOutput) {
    ListStreamConsumersOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListStreamConsumersOutput.isa = function (o) { return __isa(o, "ListStreamConsumersOutput"); };
})(ListStreamConsumersOutput || (ListStreamConsumersOutput = {}));
export var ListStreamsInput;
(function (ListStreamsInput) {
    ListStreamsInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListStreamsInput.isa = function (o) { return __isa(o, "ListStreamsInput"); };
})(ListStreamsInput || (ListStreamsInput = {}));
export var ListStreamsOutput;
(function (ListStreamsOutput) {
    ListStreamsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListStreamsOutput.isa = function (o) { return __isa(o, "ListStreamsOutput"); };
})(ListStreamsOutput || (ListStreamsOutput = {}));
export var ListTagsForStreamInput;
(function (ListTagsForStreamInput) {
    ListTagsForStreamInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTagsForStreamInput.isa = function (o) { return __isa(o, "ListTagsForStreamInput"); };
})(ListTagsForStreamInput || (ListTagsForStreamInput = {}));
export var ListTagsForStreamOutput;
(function (ListTagsForStreamOutput) {
    ListTagsForStreamOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTagsForStreamOutput.isa = function (o) { return __isa(o, "ListTagsForStreamOutput"); };
})(ListTagsForStreamOutput || (ListTagsForStreamOutput = {}));
export var MergeShardsInput;
(function (MergeShardsInput) {
    MergeShardsInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MergeShardsInput.isa = function (o) { return __isa(o, "MergeShardsInput"); };
})(MergeShardsInput || (MergeShardsInput = {}));
export var MetricsName;
(function (MetricsName) {
    MetricsName["ALL"] = "ALL";
    MetricsName["INCOMING_BYTES"] = "IncomingBytes";
    MetricsName["INCOMING_RECORDS"] = "IncomingRecords";
    MetricsName["ITERATOR_AGE_MILLISECONDS"] = "IteratorAgeMilliseconds";
    MetricsName["OUTGOING_BYTES"] = "OutgoingBytes";
    MetricsName["OUTGOING_RECORDS"] = "OutgoingRecords";
    MetricsName["READ_PROVISIONED_THROUGHPUT_EXCEEDED"] = "ReadProvisionedThroughputExceeded";
    MetricsName["WRITE_PROVISIONED_THROUGHPUT_EXCEEDED"] = "WriteProvisionedThroughputExceeded";
})(MetricsName || (MetricsName = {}));
export var ProvisionedThroughputExceededException;
(function (ProvisionedThroughputExceededException) {
    ProvisionedThroughputExceededException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ProvisionedThroughputExceededException.isa = function (o) {
        return __isa(o, "ProvisionedThroughputExceededException");
    };
})(ProvisionedThroughputExceededException || (ProvisionedThroughputExceededException = {}));
export var PutRecordInput;
(function (PutRecordInput) {
    PutRecordInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutRecordInput.isa = function (o) { return __isa(o, "PutRecordInput"); };
})(PutRecordInput || (PutRecordInput = {}));
export var PutRecordOutput;
(function (PutRecordOutput) {
    PutRecordOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutRecordOutput.isa = function (o) { return __isa(o, "PutRecordOutput"); };
})(PutRecordOutput || (PutRecordOutput = {}));
export var PutRecordsInput;
(function (PutRecordsInput) {
    PutRecordsInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutRecordsInput.isa = function (o) { return __isa(o, "PutRecordsInput"); };
})(PutRecordsInput || (PutRecordsInput = {}));
export var PutRecordsOutput;
(function (PutRecordsOutput) {
    PutRecordsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutRecordsOutput.isa = function (o) { return __isa(o, "PutRecordsOutput"); };
})(PutRecordsOutput || (PutRecordsOutput = {}));
export var PutRecordsRequestEntry;
(function (PutRecordsRequestEntry) {
    PutRecordsRequestEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutRecordsRequestEntry.isa = function (o) { return __isa(o, "PutRecordsRequestEntry"); };
})(PutRecordsRequestEntry || (PutRecordsRequestEntry = {}));
export var PutRecordsResultEntry;
(function (PutRecordsResultEntry) {
    PutRecordsResultEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutRecordsResultEntry.isa = function (o) { return __isa(o, "PutRecordsResultEntry"); };
})(PutRecordsResultEntry || (PutRecordsResultEntry = {}));
export var _Record;
(function (_Record) {
    _Record.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    _Record.isa = function (o) { return __isa(o, "Record"); };
})(_Record || (_Record = {}));
export var RegisterStreamConsumerInput;
(function (RegisterStreamConsumerInput) {
    RegisterStreamConsumerInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RegisterStreamConsumerInput.isa = function (o) { return __isa(o, "RegisterStreamConsumerInput"); };
})(RegisterStreamConsumerInput || (RegisterStreamConsumerInput = {}));
export var RegisterStreamConsumerOutput;
(function (RegisterStreamConsumerOutput) {
    RegisterStreamConsumerOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RegisterStreamConsumerOutput.isa = function (o) { return __isa(o, "RegisterStreamConsumerOutput"); };
})(RegisterStreamConsumerOutput || (RegisterStreamConsumerOutput = {}));
export var RemoveTagsFromStreamInput;
(function (RemoveTagsFromStreamInput) {
    RemoveTagsFromStreamInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RemoveTagsFromStreamInput.isa = function (o) { return __isa(o, "RemoveTagsFromStreamInput"); };
})(RemoveTagsFromStreamInput || (RemoveTagsFromStreamInput = {}));
export var ResourceInUseException;
(function (ResourceInUseException) {
    ResourceInUseException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ResourceInUseException.isa = function (o) { return __isa(o, "ResourceInUseException"); };
})(ResourceInUseException || (ResourceInUseException = {}));
export var ResourceNotFoundException;
(function (ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ResourceNotFoundException.isa = function (o) { return __isa(o, "ResourceNotFoundException"); };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
export var ScalingType;
(function (ScalingType) {
    ScalingType["UNIFORM_SCALING"] = "UNIFORM_SCALING";
})(ScalingType || (ScalingType = {}));
export var SequenceNumberRange;
(function (SequenceNumberRange) {
    SequenceNumberRange.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SequenceNumberRange.isa = function (o) { return __isa(o, "SequenceNumberRange"); };
})(SequenceNumberRange || (SequenceNumberRange = {}));
export var Shard;
(function (Shard) {
    Shard.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Shard.isa = function (o) { return __isa(o, "Shard"); };
})(Shard || (Shard = {}));
export var ShardIteratorType;
(function (ShardIteratorType) {
    ShardIteratorType["AFTER_SEQUENCE_NUMBER"] = "AFTER_SEQUENCE_NUMBER";
    ShardIteratorType["AT_SEQUENCE_NUMBER"] = "AT_SEQUENCE_NUMBER";
    ShardIteratorType["AT_TIMESTAMP"] = "AT_TIMESTAMP";
    ShardIteratorType["LATEST"] = "LATEST";
    ShardIteratorType["TRIM_HORIZON"] = "TRIM_HORIZON";
})(ShardIteratorType || (ShardIteratorType = {}));
export var SplitShardInput;
(function (SplitShardInput) {
    SplitShardInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SplitShardInput.isa = function (o) { return __isa(o, "SplitShardInput"); };
})(SplitShardInput || (SplitShardInput = {}));
export var StartingPosition;
(function (StartingPosition) {
    StartingPosition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StartingPosition.isa = function (o) { return __isa(o, "StartingPosition"); };
})(StartingPosition || (StartingPosition = {}));
export var StartStreamEncryptionInput;
(function (StartStreamEncryptionInput) {
    StartStreamEncryptionInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StartStreamEncryptionInput.isa = function (o) { return __isa(o, "StartStreamEncryptionInput"); };
})(StartStreamEncryptionInput || (StartStreamEncryptionInput = {}));
export var StopStreamEncryptionInput;
(function (StopStreamEncryptionInput) {
    StopStreamEncryptionInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StopStreamEncryptionInput.isa = function (o) { return __isa(o, "StopStreamEncryptionInput"); };
})(StopStreamEncryptionInput || (StopStreamEncryptionInput = {}));
export var StreamDescription;
(function (StreamDescription) {
    StreamDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StreamDescription.isa = function (o) { return __isa(o, "StreamDescription"); };
})(StreamDescription || (StreamDescription = {}));
export var StreamDescriptionSummary;
(function (StreamDescriptionSummary) {
    StreamDescriptionSummary.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StreamDescriptionSummary.isa = function (o) { return __isa(o, "StreamDescriptionSummary"); };
})(StreamDescriptionSummary || (StreamDescriptionSummary = {}));
export var StreamStatus;
(function (StreamStatus) {
    StreamStatus["ACTIVE"] = "ACTIVE";
    StreamStatus["CREATING"] = "CREATING";
    StreamStatus["DELETING"] = "DELETING";
    StreamStatus["UPDATING"] = "UPDATING";
})(StreamStatus || (StreamStatus = {}));
export var SubscribeToShardEvent;
(function (SubscribeToShardEvent) {
    SubscribeToShardEvent.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SubscribeToShardEvent.isa = function (o) { return __isa(o, "SubscribeToShardEvent"); };
})(SubscribeToShardEvent || (SubscribeToShardEvent = {}));
export var SubscribeToShardEventStream;
(function (SubscribeToShardEventStream) {
    SubscribeToShardEventStream.visit = function (value, visitor) {
        if (value.KMSThrottlingException !== undefined)
            return visitor.KMSThrottlingException(value.KMSThrottlingException);
        if (value.KMSDisabledException !== undefined)
            return visitor.KMSDisabledException(value.KMSDisabledException);
        if (value.KMSAccessDeniedException !== undefined)
            return visitor.KMSAccessDeniedException(value.KMSAccessDeniedException);
        if (value.KMSInvalidStateException !== undefined)
            return visitor.KMSInvalidStateException(value.KMSInvalidStateException);
        if (value.KMSNotFoundException !== undefined)
            return visitor.KMSNotFoundException(value.KMSNotFoundException);
        if (value.ResourceNotFoundException !== undefined)
            return visitor.ResourceNotFoundException(value.ResourceNotFoundException);
        if (value.SubscribeToShardEvent !== undefined)
            return visitor.SubscribeToShardEvent(value.SubscribeToShardEvent);
        if (value.ResourceInUseException !== undefined)
            return visitor.ResourceInUseException(value.ResourceInUseException);
        if (value.InternalFailureException !== undefined)
            return visitor.InternalFailureException(value.InternalFailureException);
        if (value.KMSOptInRequired !== undefined)
            return visitor.KMSOptInRequired(value.KMSOptInRequired);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
    SubscribeToShardEventStream.filterSensitiveLog = function (obj) {
        var _a;
        if (obj.KMSThrottlingException !== undefined)
            return { KMSThrottlingException: KMSThrottlingException.filterSensitiveLog(obj.KMSThrottlingException) };
        if (obj.KMSDisabledException !== undefined)
            return { KMSDisabledException: KMSDisabledException.filterSensitiveLog(obj.KMSDisabledException) };
        if (obj.KMSAccessDeniedException !== undefined)
            return { KMSAccessDeniedException: KMSAccessDeniedException.filterSensitiveLog(obj.KMSAccessDeniedException) };
        if (obj.KMSInvalidStateException !== undefined)
            return { KMSInvalidStateException: KMSInvalidStateException.filterSensitiveLog(obj.KMSInvalidStateException) };
        if (obj.KMSNotFoundException !== undefined)
            return { KMSNotFoundException: KMSNotFoundException.filterSensitiveLog(obj.KMSNotFoundException) };
        if (obj.ResourceNotFoundException !== undefined)
            return { ResourceNotFoundException: ResourceNotFoundException.filterSensitiveLog(obj.ResourceNotFoundException) };
        if (obj.SubscribeToShardEvent !== undefined)
            return { SubscribeToShardEvent: SubscribeToShardEvent.filterSensitiveLog(obj.SubscribeToShardEvent) };
        if (obj.ResourceInUseException !== undefined)
            return { ResourceInUseException: ResourceInUseException.filterSensitiveLog(obj.ResourceInUseException) };
        if (obj.InternalFailureException !== undefined)
            return { InternalFailureException: InternalFailureException.filterSensitiveLog(obj.InternalFailureException) };
        if (obj.KMSOptInRequired !== undefined)
            return { KMSOptInRequired: KMSOptInRequired.filterSensitiveLog(obj.KMSOptInRequired) };
        if (obj.$unknown !== undefined)
            return _a = {}, _a[obj.$unknown[0]] = "UNKNOWN", _a;
    };
})(SubscribeToShardEventStream || (SubscribeToShardEventStream = {}));
export var SubscribeToShardInput;
(function (SubscribeToShardInput) {
    SubscribeToShardInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SubscribeToShardInput.isa = function (o) { return __isa(o, "SubscribeToShardInput"); };
})(SubscribeToShardInput || (SubscribeToShardInput = {}));
export var SubscribeToShardOutput;
(function (SubscribeToShardOutput) {
    SubscribeToShardOutput.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.EventStream && { EventStream: "STREAMING_CONTENT" }))); };
    SubscribeToShardOutput.isa = function (o) { return __isa(o, "SubscribeToShardOutput"); };
})(SubscribeToShardOutput || (SubscribeToShardOutput = {}));
export var Tag;
(function (Tag) {
    Tag.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Tag.isa = function (o) { return __isa(o, "Tag"); };
})(Tag || (Tag = {}));
export var UpdateShardCountInput;
(function (UpdateShardCountInput) {
    UpdateShardCountInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateShardCountInput.isa = function (o) { return __isa(o, "UpdateShardCountInput"); };
})(UpdateShardCountInput || (UpdateShardCountInput = {}));
export var UpdateShardCountOutput;
(function (UpdateShardCountOutput) {
    UpdateShardCountOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateShardCountOutput.isa = function (o) { return __isa(o, "UpdateShardCountOutput"); };
})(UpdateShardCountOutput || (UpdateShardCountOutput = {}));
//# sourceMappingURL=index.js.map